/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Company_User_Create_ErrorInputs */

const en_admin_create_company_user_create_error = /** @type {(inputs: Admin_Create_Company_User_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while creating the user.`)
};

const de_admin_create_company_user_create_error = /** @type {(inputs: Admin_Create_Company_User_Create_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Anlegen des Benutzers ist ein Fehler aufgetreten.`)
};

/**
* | output |
* | --- |
* | "An error occurred while creating the user." |
*
* @param {Admin_Create_Company_User_Create_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_company_user_create_error = /** @type {((inputs?: Admin_Create_Company_User_Create_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Company_User_Create_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_company_user_create_error(inputs)
	return en_admin_create_company_user_create_error(inputs)
});